import React from 'react';

import { useSentryShopEffect } from './useSentryShopEffect';
import { useUserPropertiesEffect } from './useUserPropertiesEffect';

export const ShopSideEffects = React.memo(function ShopSideEffects() {
  useSentryShopEffect();
  useUserPropertiesEffect();

  return null;
});
